function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import appApis from '@/services/services';
import assignments_service from '@/apps/data-platform/services/tables_views/assignments_service';
import { textsDefaul, envConfig, TYPE_CHANGE_METADA, TAG_QUERIES, UI_CUSTOM_PERMISIONS, isFOHDomain } from '@/js/constants';
import utils from '@/js/utils';
import PaginationVue from '@/components/PaginationVue.vue';
import PaginationCatalog from '@/components/PaginationCatalog.vue';
import StateComponent from '@/components/StateComponent.vue';
import FormMetadata from '@/components/FormMetadata.vue';
import FormMetadataTableComponent from '@/apps/data-platform/components/FormMetadataTableComponent.vue';
import { mapState } from 'vuex';
import tasks from '@/js/tasks';
import SearchInTableNew from '@/components/refactoring/SearchInTable.vue';
export default {
  name: 'TableAssignmentsPage',
  components: {
    PaginationVue: PaginationVue,
    PaginationCatalog: PaginationCatalog,
    StateComponent: StateComponent,
    FormMetadata: FormMetadata,
    SearchInTableNew: SearchInTableNew,
    FormMetadataTableComponent: FormMetadataTableComponent
  },
  data: function data() {
    return {
      DIALOG_ASSIGN: "DIALOG_ASSIGN",
      MODAL_NAME_ACCESS: 'assign-tpl',
      tablas: [],
      tablas_bk: [],
      collapse_filter: false,
      queryResponse: null,
      tplToUpdate: {},
      TYPE_CHANGE_METADA: TYPE_CHANGE_METADA,
      PAGE_SIZE: envConfig.pagintaionSize,
      PAGE_TAGS_SIZE: envConfig.pagintaionTagsSize,
      Q_DEFAULT: TAG_QUERIES.ALL_WITHOUT_OWNER,
      messageEmptyList: textsDefaul.LOADING,
      filter: '',
      filterOn: [],
      paramsSearch: {},
      isNewQuery: true,
      userHasPermission: false,
      dialogFlag: false,
      filter_enabled: false,
      //true,
      pagination: {
        current: 1,
        limit: 10,
        total: 0,
        offset: 0
      },
      pagination_synapse: {
        current: 1,
        limit: 10,
        total: 0,
        offset: 0
      },
      nextToken: {},
      key_pagination: 1,
      key_pagination_synapse: 1,
      key_table: 1,
      key_table_synapse: 1000,
      isSynapse: false,
      source: "bigquery",
      is_pendings_details: false,
      primera_busqueda: true,
      key_view: 1,
      objToRequest: {}
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['projects', 'catalogs', 'isSynapseActive'])), {}, {
    // Descarga dividida por plantilla (tablas/columnas): solo dominios FOH y,
    // para poder probarla, siempre en entorno local
    showSplitMetadataDownload: function showSplitMetadataDownload() {
      return isFOHDomain(window.userInfo.domain) || process.env.VUE_APP_ENV === 'local' || process.env.NODE_ENV === 'development';
    },
    getBreadcrumbs: function getBreadcrumbs() {
      return [{
        text: this.traductor('my_tasks.subtitle_table_assignment'),
        disabled: true
      }];
    },
    headers: function headers() {
      return [{
        text: this.traductor('my_tasks.tablas_tasks.table'),
        value: 'tableReference.tableId',
        sortable: true,
        class: 'text-left'
      }, {
        text: this.traductor('my_tasks.tablas_tasks.columns'),
        value: 'schema.fields.length',
        sortable: true,
        width: "5%",
        align: 'center'
      }, {
        text: this.traductor('my_tasks.tablas_tasks.rows'),
        value: 'numRows',
        sortable: true,
        align: 'center'
      }, {
        text: this.traductor('my_tasks.tablas_tasks.creation_date'),
        value: 'creationTime',
        sortable: true,
        align: 'center'
      }, {
        text: this.traductor('my_tasks.tablas_tasks.actions'),
        value: 'actions',
        sortable: false,
        align: 'center'
      }];
    },
    isEmptyTable: function isEmptyTable() {
      return !(this.queryResponse && this.queryResponse.tables);
    },
    getClassTable: function getClassTable() {
      if (this.filter_enabled) return 'col-md-9 col-sm-12';else return 'col-sm-12';
    },
    texts: function texts() {
      return {
        assign: this.traductor('my_tasks.assign_modal')
      };
    }
  }),
  created: function created() {
    this.reloadList();
    this.userHasPermission = this.hasPermission();
  },
  methods: {
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    onEnableFilter: function onEnableFilter() {
      this.filter_enabled = !this.filter_enabled;
    },
    hasPermission: function hasPermission() {
      var roles = UI_CUSTOM_PERMISIONS['SYNC_TABLE']['roles'];
      var status = false;
      var _iterator = _createForOfIteratorHelper(roles),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var rol = _step.value;
          if (utils.hasRole(rol)) {
            status = true;
            break;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return status;
    },
    sendToSearch: function sendToSearch(q, domain, allDomains) {
      var conditions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
      var source = arguments.length > 4 ? arguments[4] : undefined;
      this.source = source;
      if (source == 'synapse') {
        this.isSynapse = true;
      } else {
        this.isSynapse = false;
      }
      if (!q) {
        q = '';
      }
      if (conditions && Object.keys(conditions).indexOf("clear") != -1) {
        if (conditions["clear"]) {
          this.primera_busqueda = true;
        }
      }
      this.pagination_synapse.current = 1;
      this.pagination.current = 1;
      this.pagination.tokens = {};
      this.pagination.next_page_token = {};
      this.key_pagination += 1;
      this.Q_DEFAULT = "".concat(TAG_QUERIES.ALL_WITHOUT_OWNER, " ").concat(q); // add input to filter
      var params = {
        query: this.Q_DEFAULT,
        domain: domain,
        allDomains: allDomains,
        conditions: conditions,
        isSynapse: this.isSynapse,
        source: this.source
      };
      this.isNewQuery = true;
      this.reloadList(params); // reload list
    },
    asyncTableWithSchema: function asyncTableWithSchema(item) {
      var rowData = utils.cloneJSON(item);
      var params = {
        relativeResourceName: rowData.relativeResourceName,
        index_node: rowData.index_node,
        domain_table: rowData.domain_table
      };
      assignments_service.syncTableSchema(params).then(function (response) {
        if (response.code === 200) {
          var message = response.message;
          tasks.toast.success(message);
          //alert(message)
        }
      }).catch(function (e) {
        utils.printError(e);
      });
    },
    isProdTable: function isProdTable(item) {
      if (item.tags && item.tags.length > 0) {
        console.log(item.tags);
        var find = false;
        item.tags.forEach(function (tag) {
          if (tag.templateDisplayName == "tpl_tables") {
            if (tag.fields.env && tag.fields.env.enumValue && tag.fields.env.enumValue.displayName == "prod") find = true;
          }
        });
        return find;
      }
      return false;
    },
    openViewTpl: function openViewTpl(item) {
      var _this = this;
      // properties: item, index, event
      var i;
      var rowData = utils.cloneJSON(item);
      // get template fields
      var params = {
        relativeResourceName: rowData.relativeResourceName,
        pageSize: this.PAGE_TAGS_SIZE,
        email: window.userInfo.email,
        index_node: rowData.index_node,
        domain_table: rowData.domain_table,
        source: this.source
      };
      console.log("aqui: ", params);
      assignments_service.getListTagEntry(params).then(function (response) {
        if (response.code === 200) {
          var responseTPL = response.data;
          _this.objToRequest = responseTPL;
          _this.objToRequest.item = rowData;
          _this.objToRequest.tipo = 'edicion'; // LINEA AGREGADA
          _this.$refs['MODAL_NAME_METADATA_VIEW'].onOpen();
          //this.$bvModal.show(this.MODAL_NAME_ACCESS)
        }
      }).catch(function (e) {
        utils.printError(e);
        //this.openEditTpl(item)
      });
      return true;
    },
    openEditTpl: function openEditTpl(item) {
      var _this2 = this;
      console.log("openEditTpl", item);
      // properties: item, index, event
      var i;
      var rowData = utils.cloneJSON(item);
      // get template fields
      var params = {
        relativeResourceName: rowData.relativeResourceName,
        pageSize: this.PAGE_TAGS_SIZE,
        email: window.userInfo.email,
        index_node: rowData.index_node,
        domain_table: rowData.domain_table,
        source: this.source,
        projectId: item.tableReference.projectId,
        datasetId: item.tableReference.datasetId,
        tableId: item.tableReference.tableId
      };
      console.log("aqui: ", params);
      assignments_service.getListTagEntry(params).then(function (response) {
        if (response.code === 200) {
          var responseTPL = response.data;
          console.log(responseTPL);
          for (i = 0; i < responseTPL.objects.tags.length; i++) {
            if (!responseTPL.objects.tags[i].fields.business_term) {
              if (responseTPL.objects.tags[i].column) {
                responseTPL.objects.tags[i].fields.business_term = {};
                responseTPL.objects.tags[i].fields.business_term.displayName = 'Business Term';
                responseTPL.objects.tags[i].fields.business_term.stringValue = '';
              }
            }
          }
          _this2.tplToUpdate = responseTPL;
          _this2.tplToUpdate.item = rowData;
          _this2.tplToUpdate.tipo = 'edicion'; // LINEA AGREGADA
          _this2.tplToUpdate.origin = 'assignments';
          _this2.$refs[_this2.DIALOG_ASSIGN].onOpen();
          //this.$bvModal.show(this.MODAL_NAME_ACCESS)
        }
      }).catch(function (e) {
        utils.printError(e);
        //this.openEditTpl(item)
      });
      return true;
    },
    assignOwner: function assignOwner() {
      this.$refs[this.DIALOG_ASSIGN].onClose();
      //this.$bvModal.hide(this.MODAL_NAME_ACCESS)
      // const params = {
      //   ...this.paramsSearch,
      //   nextToken: undefined
      // }
      // this.reloadList(params)
      return true;
    },
    changePagina: function changePagina(page) {
      console.log(page, this.pagination.tokens);
      if (page == 1) {
        this.nextToken = {};
        this.pagination.tokens = null;
        this.pagination.next_page_token = {};
      } else {
        this.nextToken = this.pagination.tokens[page];
      }
      this.reloadList();
    },
    processParams: function processParams(params) {
      var _ref = params || {},
        _ref$email = _ref.email,
        email = _ref$email === void 0 ? window.userInfo.email : _ref$email,
        _ref$domain = _ref.domain,
        domain = _ref$domain === void 0 ? window.userInfo.domain : _ref$domain,
        _ref$query = _ref.query,
        query = _ref$query === void 0 ? this.Q_DEFAULT || '' : _ref$query,
        _ref$pageSize = _ref.pageSize,
        pageSize = _ref$pageSize === void 0 ? this.PAGE_SIZE : _ref$pageSize,
        _ref$searchWithTags = _ref.searchWithTags,
        searchWithTags = _ref$searchWithTags === void 0 ? false : _ref$searchWithTags,
        _ref$allDomains = _ref.allDomains,
        allDomains = _ref$allDomains === void 0 ? false : _ref$allDomains,
        _ref$approval_flow = _ref.approval_flow,
        approval_flow = _ref$approval_flow === void 0 ? false : _ref$approval_flow,
        _ref$nextToken = _ref.nextToken,
        nextToken = _ref$nextToken === void 0 ? undefined : _ref$nextToken,
        _ref$conditions = _ref.conditions,
        conditions = _ref$conditions === void 0 ? undefined : _ref$conditions;
      this.paramsSearch = nextToken === undefined ? {
        email: email,
        domain: domain,
        query: query,
        pageSize: pageSize,
        searchWithTags: searchWithTags,
        allDomains: allDomains,
        approval_flow: approval_flow,
        nextToken: nextToken,
        conditions: conditions
      } : _objectSpread(_objectSpread({}, this.paramsSearch), {}, {
        nextToken: nextToken
      });
      this.paramsSearch.projects = this.projects;
      this.paramsSearch.catalogs = this.catalogs;
      this.paramsSearch.pagination_synapse = {
        "limit": this.pagination_synapse.limit,
        "offset": (this.pagination_synapse.current - 1) * this.pagination_synapse.limit,
        "name": this.paramsSearch.conditions ? this.paramsSearch.conditions.name : null,
        "schema": null
      };
      return this.paramsSearch;
    },
    reloadList: function reloadList(params) {
      var _this3 = this;
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
      var defaultParams = this.processParams(params);
      defaultParams["nextToken"] = this.nextToken;
      defaultParams["isSynapse"] = this.isSynapse;
      defaultParams["source"] = this.source;
      //appApis
      //  .queryServiceNew(defaultParams)
      assignments_service.getAssignments(defaultParams).then(function (response) {
        if (response && response.code === 200) {
          if (response.data.next_page_token && Object.keys(response.data.next_page_token).length > 0) {
            console.log("has next page");
            if (!_this3.pagination.tokens) _this3.pagination.tokens = {};
            _this3.pagination.tokens[_this3.pagination.current + 1] = response.data.next_page_token;
            _this3.pagination.next_page_token = response.data.next_page_token;
          } else {
            console.log("no next page");
            _this3.pagination.next_page_token = {};
          }
          _this3.key_pagination += 1;
          _this3.queryResponse = response.data || {};
          console.log(response.data);
          _this3.tablas = response.data.tables;
          _this3.tablas_bk = response.data.tables;
          if (_this3.isSynapse) {
            //this.pagination_synapse.total = response.data.tables.length
            _this3.pagination_synapse.total = response.data.pagination ? response.data.pagination.total : 0;
            _this3.key_pagination_synapse += 1;
          }
          _this3.messageEmptyList = response.data.tables.length === 0 ? textsDefaul.NOT_TABLES : null;
        } else if (response && response.code === 400) {
          // alert(response.message)
        }
        _this3.isNewQuery = false;
        callback && callback(response);
      }).then(function () {
        if (_this3.queryResponse.tables.length > 0) {
          _this3.getDetails();
        }
      }).catch(function (e) {
        utils.printError(e);
        // this.reloadList(defaultParams, callback)
      });
    },
    changePaginaSynapse: function changePaginaSynapse(event) {
      console.log(this.pagination_synapse);
      this.reloadList();
      //this.getDetails()
    },
    getRowsViewed: function getRowsViewed(tablas) {
      var inicio = (this.pagination_synapse.current - 1) * 10;
      var final = inicio + 10;
      if (final > tablas.length) final = tablas.length;
      return tablas.slice(inicio, final);
    },
    getDetails: function getDetails() {
      var _this4 = this;
      if (this.isSynapse) {
        return;
      }
      var tables = [];
      this.queryResponse.tables.forEach(function (item) {
        tables.push({
          projectId: item.tableReference.projectId,
          datasetId: item.tableReference.datasetId,
          tableId: item.tableReference.tableId,
          domain_table: item.domain_table,
          source: _this4.source
        });
      });
      var params = {
        'tables': this.isSynapse ? this.getRowsViewed(tables) : tables
      };
      this.is_pendings_details = true;
      assignments_service.getTablesDetails(params).then(function (response2) {
        _this4.is_pendings_details = false;
        console.log(response2);
        if (response2.data) {
          var _loop = function _loop(key) {
            if (_this4.isSynapse) {
              var items = _this4.queryResponse.tables.filter(function (x) {
                return x.id.replace(":", ".") == response2.data[key].id.replace(":", ".");
              });
              items.forEach(function (y) {
                var ole = _objectSpread(_objectSpread({}, y), response2.data[key]);
                var index = _this4.queryResponse.tables.indexOf(y);
                if (index != -1) {
                  _this4.queryResponse.tables[index] = ole;
                }
              });
            } else {
              var _items = _this4.queryResponse.tables.filter(function (x) {
                return x.id == response2.data[key].id;
              });
              _items.forEach(function (y) {
                var ole = _objectSpread(_objectSpread({}, y), response2.data[key]);
                var index = _this4.queryResponse.tables.indexOf(y);
                if (index != -1) {
                  _this4.queryResponse.tables[index] = ole;
                }
              });
            }
          };
          for (var key in response2.data) {
            _loop(key);
          }
          _this4.key_table += 1;
        }
      }).catch(function (error) {
        _this4.is_pendings_details = false;
      });
    }
  }
};